import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import FieldRadioButton from '../FieldRadioButton/FieldRadioButton';
import { PrimaryButton } from '../Button/Button';
import { sendEmail } from '../../util/api';
import css from './OrderPanel.module.css';
import FieldTextInput from '../FieldTextInput/FieldTextInput';
import { useIntl } from 'react-intl';

const REPORT_REASONS = [
  { value: 'Het is onnauwkeurig of onjuist', label: 'Het is onnauwkeurig of onjuist' },
  {
    value: 'Het is geen echte plek om te verblijven',
    label: 'Het is geen echte plek om te verblijven',
  },
  { value: 'Het is een oplichterij', label: 'Het is een oplichterij' },
  { value: 'Het is beledigend', label: 'Het is beledigend' },
  { value: 'Het is iets anders', label: 'Het is iets anders' },
];

const validate = values => {
  const errors = {};
  if (!values.reason) {
    errors.reason = 'Please select a reason.';
  }
  if (values.reason === 'other' && !values.details) {
    errors.details = 'Please provide more details.';
  }
  return errors;
};

const ReportListingForm = ({ listingId, currentUserId }) => {
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const intl = useIntl();

  const handleSubmit = async values => {
    setSubmitSuccess(false);
    try {
      const htmlContent = `
        <p><b>Listing ID:</b> ${listingId}</p>
        <p><b>Reason:</b> ${values.reason}</p>
        <p><b>Reported By User ID:</b> ${currentUserId}</p>
      `;
      await sendEmail({
        subject: 'Listing Report',
        htmlContent,
      });
      setSubmitSuccess(true);
    } catch (e) {
      console.log('Failed to send report. Please try again.');
    }
  };

  return (
    <div className={css.reportListingForm}>
      <div>
        <div className={css.reportListingForm__title}>
          {intl.formatMessage({ id: 'ReportListingForm.title' })}
        </div>
        <div className={css.reportListingForm__desc}>
          {intl.formatMessage({ id: 'ReportListingForm.desc' })}
        </div>
      </div>
      <FinalForm
        onSubmit={handleSubmit}
        validate={validate}
        render={({ handleSubmit, submitting, values, errors, dirty }) => (
          <form onSubmit={handleSubmit}>
            <div className={css.reportListingForm__options}>
              {REPORT_REASONS.map(option => (
                <FieldRadioButton
                  key={option.value}
                  id={`report-reason-${option.value}`}
                  name="reason"
                  value={option.value}
                  label={option.label}
                />
              ))}
            </div>
            {values.reason === 'other' && (
              <FieldTextInput
                className={css.reportListingForm__textarea}
                name="details"
                id="report-details"
                type="textarea"
                label="Please provide more details"
                maxLength={500}
              />
            )}
            {dirty && (errors.reason || errors.details) && (
              <div className={css.reportListingForm__error}>{errors.reason || errors.details}</div>
            )}
            {submitSuccess && (
              <div style={{ color: 'green', marginBottom: 8 }}>
                {intl.formatMessage({ id: 'ReportListingForm.success' })}
              </div>
            )}
            <div className={css.reportListingForm__button}>
              <PrimaryButton type="submit" inProgress={submitting} disabled={submitting}>
                {intl.formatMessage({ id: 'ReportListingForm.submit' })}
              </PrimaryButton>
            </div>
          </form>
        )}
      />
    </div>
  );
};

export default ReportListingForm;
